export type PreviewPage = {
  image: string
  alt: string
  tag: string
  title: string
  line: string
}

export const volume4Pages: PreviewPage[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/jpP4WaDZuZcU2c75XR2ZG7/vol4-p08-session-40.png',
    alt: 'Volume 4, page 8: Session 40 — Base Position and the Split Step, 45 minutes. Objective, setup, group split, court diagram, warm-up, skill block, applied game, five-step movement sequence, watch-for and fix, and three difficulty levels.',
    tag: 'Ready-to-run session',
    title: 'Every session, done for you',
    line: 'Objective, setup, timings, cues, the common mistake and the fix — on one page.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/c8DYck5bJgfDP1sdzerAxa/vol4-p20-four-corner-grid.png',
    alt: 'Volume 4, page 20: The 4-Corner Coverage Grid. A top-down badminton court with arrows from the base to the front-forehand, front-backhand, rear-forehand and rear-backhand corners, plus a coach’s note.',
    tag: 'Framework',
    title: 'Court diagrams you read in seconds',
    line: 'Top-down courts, clear arrows, zero walls of text.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/k1HRdXzPrrAuMbB4odgAhD/vol4-p14-flat-feet-vs-split-step.png',
    alt: 'Volume 4, page 14: Flat Feet vs a Loaded Split Step. A side-by-side “So not / So yes” comparison of a player standing flat-footed and a player loaded on the balls of the feet, with the cue and the fix.',
    tag: 'So not / So yes',
    title: 'Spot the mistake. Show the fix.',
    line: 'Side-by-side visuals your players get instantly.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/dhNGGd2mj73dmDecSthLty/vol4-p06-split-step-clock.png',
    alt: 'Volume 4, page 6: The Split-Step Clock. A clock face showing footwork timing — recovered at 12, the split at 3, the push at 6, shot and recover at 9 — with a coach’s note on timing the split to the opponent’s contact.',
    tag: 'Named method',
    title: 'Frameworks players actually remember',
    line: 'The Split-Step Clock turns footwork timing into one simple picture.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tzGvJ1KvxhgyqTZm1Tj2jT/vol4-p50-field-card.png',
    alt: 'Volume 4, page 50: Movement and Defence Coach’s Field Card. Before-you-start checklist, session formula timings, ways to make drills easier or harder, universal cues, a safety reminder and an index of sessions 40 to 51.',
    tag: 'Printable',
    title: 'Print it. Keep it courtside.',
    line: 'Checklists, cues and session formula on a single field card.',
  },
]
